import { render, staticRenderFns } from "./u-tit-wrap-default.vue?vue&type=template&id=5ab4193c&scoped=true&"
import script from "./u-tit-wrap-default.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4193c",
  null
  
)

export default component.exports